import React, { useEffect, useState } from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Card} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
//Landing Pages
import Home from './Container/LandingPage/home';
import Footer_not_login from './footer_not_login';
import Navbar_Not_Login from './navbar_not_login';
import Login from './Container/LandingPage/Login';
import SignUp from './Container/LandingPage/SignUp';
import AdminDashboard from './Container/AdminDashbord/index';
import Reports from './Container/Reports';
import Navbar from './navbar'
import CreateUser from './Container/CreateUser';
import CreateScheme from './Container/createScheme';
import RaiseRequest from './Container/RaiseRequest';
import AllUserForAdmin from './Container/alluserforadmin';
import './Container/AdminDashbord/Body.css'
import image8 from './images/update-profile-user-svgrepo-com@2x.png';
import image9 from './images/156533@2x.png';
import call_logs from './images/call_logs.png'
import image10 from './images/noun_complaint_514082@2x.png';
import image11 from './images/male-user-icon-in-suit-svgrepo-com@2x.png';
import image12 from './images/report-3-128.png';
import image14 from './images/settings-128.png';
import homeimg from './images/home-1.1s-47px.png'
import alluser from './images/alluser.png'
import Profile from './Container/profile';
import axios from 'axios';
import Call_Logs from './Container/call_logs';
import AboutUs from './aboutUs';
import ContactUs from './contactUs';
import UserDetailsSelect from './Container/LandingPage/UserDetailsSelect'
import session from 'express-session';
import SelectSchemeReport from './Container/RaiseRequest/SelectSchemeReport';
import RaiseReqSelectScheme from './Container/RaiseRequest/RaiseReqSelectScheme';
import Requesthistory from './Container/Requesthistory';

import { Button, Modal } from 'react-bootstrap';

import './router.css';
let login_details_Count=0;
const Routers=()=>{
    let history=useHistory()

   /* const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true); */
   

    const [data, setdata]=useState({
        auth:false,
        loading:false,
        userDetails:{}
    })
    
    const [user_role_selected, setuser_role_selected]=useState(false);
    let [allRole_userr, set_all_role_user]=useState([
        {label:'Client Admin', role_enable:false, slable:'is_client_admin'}, 
        {label:'Client User', role_enable:false, slable:'is_client_user'}, 
        {label:'CRM', role_enable:false, slable:'is_crm'}, 
        {label:'OG Manager', role_enable:false, slable:'is_ogmanager'},
        {label:'Operation Executive', role_enable:false, slable:'is_oprtn_exectv'},
        {label:'PROCUREMENT', role_enable:false, slable:'is_procurement'},
        {label:'SS Admin', role_enable:false, slable:'is_ssadmin'},
        {label:'Support User', role_enable:false, slable:'is_supportuser'},
        {label:'Support User Srishti', role_enable:false, slable:'is_supportusersrishti'}
       ])
      const [selectedRoleLabel, setselectedrolelabel]=useState('') 
     
    const GetUserDetails=()=>{
        axios.get('/currentuser')
        .then(res=>{
            if(res.data.error){
                setdata({...data, auth:false,loading:true, userDetails:{}})
                history.replace('/')

            }else{
                setdata({...data, auth:true,loading:true, userDetails:res.data})
                allRole_userr.forEach((key, i)=>{
                    if(res.data[key.slable]){
                        let naslluser=[...allRole_userr]
                        naslluser[i].role_enable=true
                        console.log('jfdnjkdfnkjdfkj',res.data[key.slable], naslluser, i);
                        setselectedrolelabel(key.label)
                        set_all_role_user(naslluser)
                        setuser_role_selected(true)
                        // console.log('trrrye ', key.slable)
                   
                        
                    }
                    // if(data.auth===true){
                    //     console.log('userdet')
                    //     history.replace('/')
                    // }
                    // console.log('login_details_Count',login_details_Count)
                    // if(login_details_Count===0){
                    //     history.replace('/')
                    //     login_details_Count+=1
                    // }
                    // console.log('login_details_Count',login_details_Count)

                })
                axios.get('/call_log_in?user_id='+res.data.id)                 
            }
        })
    }

    console.log('allRole_userr', allRole_userr)
   
    useEffect(()=>{
        GetUserDetails()
       
    }, [])
    if(data.loading){
    return(
        <div>
            {data.auth?
            <div>
            {(user_role_selected||data.userDetails.corporate_id===1119)?
                <div>
                <Navbar userRole={selectedRoleLabel} useserdetails={data.userDetails} />
                <Card className="Mainclass" style={{paddingTop:5}}>
                <Card className="Container1" style={{minHeight:'73vw'}}>
         <Card className="minicontainer">
               <Link to='/' className="menu1">
                    <div style={{textAlign:'-webkit-center'}}>
                        <div style={{height:50, width:50}}>
                            <img src={homeimg} alt="updateprof" height="100%" width="100%"/>
                        </div>
                        <br/>
                        <p className="imgtext"><b>Home</b></p>
                    </div>
                </Link>
                <br/>
                <br/>
                {(allRole_userr[0].role_enable===true||allRole_userr[1].role_enable===true||allRole_userr[2].role_enable===true||allRole_userr[3].role_enable===true||allRole_userr[7].role_enable===true||allRole_userr[4].role_enable===true||allRole_userr[8].role_enable===true||data.userDetails.corporate_id===1119)&&
                <Link to='/reports' className="menu1">
                    <div style={{textAlign:'-webkit-center'}}>
                        <div  style={{height:50, width:50}}>
                            <img src={image12} alt="reports" height="100%" width="100%"/>
                        </div>
                        <br/>
                        <p className="imgtext"><b>REPORTS</b></p>
                    </div>
                </Link>
                }
                <br/>
                <br/>


                {(allRole_userr[0].role_enable===true||allRole_userr[1].role_enable===true||allRole_userr[2].role_enable===true||allRole_userr[3].role_enable===true||allRole_userr[7].role_enable===true||allRole_userr[4].role_enable===true||allRole_userr[8].role_enable===true||data.userDetails.corporate_id===1119)&&
                <Link to='/requesthistory' className="menu1">
                    <div style={{textAlign:'-webkit-center'}}>
                        <div  style={{height:50, width:50}}>
                            <img src={image12} alt="reports" height="100%" width="100%"/>
                        </div>
                        <br/>
                        <p className="imgtext"><b>Request History</b></p>
                    </div>
                </Link>
                }
                <br/>
                <br/>

             {/* {(allRole_userr[3].role_enable===false)&&
                <Link className="menu1" to="/raiserequest">
                    <div style={{textAlign:'-webkit-center'}}>
                        <div  style={{height:50, width:50}}>
                            <img src={image10} alt="raisereqs" height="100%" width="100%"/>
                        </div>
                        <br/>
                        <p className="imgtext"><b>RAISE REQUESTS</b></p>
                    </div>
                </Link>
                } */}

                {(allRole_userr[3].role_enable===false)&&
                    <Link className="menu1" to="/raise_req_select_scheme">
                {/* <Button variant="primary" onClick={handleShow}> */}
                <div style={{textAlign:'-webkit-center'}}>
                        <div  style={{height:50, width:50}}>
                            <img src={image10} alt="raisereqs" height="100%" width="100%"/>
                        </div>
                        <br/>
                        <p className="imgtext"><b>RAISE REQUESTS</b></p>
                    </div>
                 {/* </Button> */}
                 </Link>
                }

      {/* <Modal show={show} onHide={handleClose}>
        <SelectSchemeReport />
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}


                {(data.userDetails.is_admin||data.userDetails.is_super_admin)&&
                 
                <div>
                    <br/>
                    <br/>
              {(allRole_userr[3].role_enable===false)&&
                    <Link className="menu1" to="/userlist">
                        <div style={{textAlign:'-webkit-center'}}>
                            <div  style={{height:50, width:50}}>
                                <img src={alluser} alt="raisereqs" style={{
                                    filter:'brightness(0) invert(1)'
                                }} height="100%" width="100%"/>
                            </div>
                            <br/>
                            <p className="imgtext"><b>All User</b></p>
                        </div>
                    </Link>
                    }
                    <br/>
                    <br/>
                </div>
                }
                <br/>
          <div style={{textAlign:'center', paddingBottom:100}}>
             {(allRole_userr[3].role_enable===false)&&
                    <Link  to="/calllogs">
                        <div style={{textAlign:'-webkit-center'}}>
                            <div  style={{height:50, width:50}}>
                                <img src={call_logs}
                                style={{
                                    filter:'brightness(0) invert(1)'
                                }} alt="settings" height="100%" width="100%"/>
                            </div>
                            <p className="imgtext"><b>Call Logs</b></p>
                        </div>
                    </Link>
             }
                </div>
                <br/>
                <br/>
               
          <div style={{textAlign:'center', paddingBottom:100}}>
                {(allRole_userr[3].role_enable===false)&&
                    <Link  to="/profile">
                        <div style={{textAlign:'-webkit-center'}}>
                            <div  style={{height:50, width:50}}>
                                <img src={image14} alt="settings"
                                
                                height="100%" width="100%"/>
                            </div>
                            <p className="imgtext"><b>Setting</b></p>
                        </div>
                    </Link>
                }
                </div>
                
                </Card>

               
                </Card>

                    <Switch>
                        <Route exact path='/' component={()=><AdminDashboard userData={data.userDetails}/>}/>
                        <Route exact path='/reports' component={()=><Reports userData={data.userDetails}/>}/>
                        <Route exact path='/requesthistory' component={()=><Requesthistory userData={data.userDetails}/>}/>
                        <Route exact path='/createuser' component={()=><CreateUser userData={data.userDetails}/>}/>
                        <Route exact path='/createscheme' component={()=><CreateScheme userData={data.userDetails}/>}/>
                        <Route exact path='/raiserequest' component={()=><RaiseRequest userData={data.userDetails}/>}/>
                        <Route exact path='/userlist' component={()=><AllUserForAdmin userData={data.userDetails}/>}/>
                        <Route exact path='/profile' component={()=><Profile userData={data.userDetails}/>}/>
                        <Route exact path='/calllogs' component={()=><Call_Logs userData={data.userDetails}/>}/>
                        {/* <Route exact path='/reportsss' component={()=><SelectSchemeReport userData={data.userDetails} /> } /> */}
                        <Route exact path='/raise_req_select_scheme' component={()=><RaiseReqSelectScheme userData={data.userDetails} />} />
                </Switch>
                    
             {/* <AdminDashboard userData={data.userDetails} /> */}
             
             </Card> 
               
                <div style={{
                    position:'fixed',
                    left:0,
                    bottom:0,
                    width:'100%',
                    backgroundColor:'#3C4852',
                    color:'#FFF',
                   height:40,
                   display:'flex',alignItems:'center', justifyContent:'center'
                }}>
                <span>@ Powered by SuperSeva</span>
                </div>
            </div>
                :
            <div>
                <Switch>
                    <Route exact path='/' component={()=><UserDetailsSelect userData={data.userDetails}/>}/>
                    <Route exact path='/' component={()=><AdminDashboard userData={data.userDetails}/>}/>
                </Switch>
            </div>
            }
            
       </div>

            :
            <div>
                <div>
                
                    <Navbar_Not_Login userData={data.userDetails} />
                    {/* <SelectSchemeReport userData={data.userDetails} /> */}
                </div>
                <div style={{position:'absolute', top:140, width:'100%'}}>
                    <Switch>
                        <Route exact path='/' component={Home}/>
                        <Route exact path='/login' component={Login}/>
                        <Route exact path='/reports' component={()=><SelectSchemeReport userData={data.userDetails} /> } />
                        <Route exact path='/signup' component={SignUp}/>
                        <Route exact path='/contact' component={ContactUs}/>
                        <Route exact path='/raiserequests' component={()=><RaiseRequest userData={data.userDetails}/>}/>
                        {/* <Route exact path='/raise_req_select_scheme' component={()=><RaiseReqSelectScheme userData={data.userDetails} />} /> */}
                        <Route exact path='/about' component={AboutUs}/>
                   
                    </Switch>
                    <Footer_not_login/>
                </div>
            </div>
            }
        </div>
    )}else{
        return(
            <>
                <div>
                    <div>loading ....</div>
                    
                    <div class="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </>
        )
    }
}
export default Routers;